import dayjs from 'dayjs';

/**
 * Validates campaign details (Panel 1)
 */
export const validateCampaignDetails = (
    campaignName: string,
    selectedAdAccountId: string,
    selectedFbPageId: string,
    selectedWaba: string | null,
    isMilestoneCheckPassed: boolean | null
): boolean => {
    return !!campaignName && !!selectedAdAccountId && !!selectedFbPageId && !!selectedWaba && !!isMilestoneCheckPassed;
};

/**
 * Validates ad set details (Panel 2)
 */
export const validateAdSetDetails = (
    adSetName: string,
    useSavedAudiences: boolean,
    useCustomAudiences: boolean,
    savedAdSetName: string | null,
    customAdSetName: string | null,
    selectLocations: any[],
    excludedLocations: any[],
    selectedGender: string,
    ageRange: [number, number],
    selectedPlatforms: string[],
    dailyBudget: number | undefined,
    startDate: dayjs.Dayjs | null,
    setBeneficiary?: boolean,
    beneficiary?: string | null
): boolean => {
    // console.log(adSetName, useCustomAudiences, selectLocations, selectedGender, ageRange, selectedPlatforms, dailyBudget, startDate);
    return (
        !!adSetName &&
        (selectLocations.length > 0 || useCustomAudiences) &&
        !!selectedGender &&
        ageRange[0] >= 18 &&
        ageRange[1] <= 65 &&
        selectedPlatforms.length > 0 &&
        dailyBudget !== undefined &&
        startDate !== null &&
        (!setBeneficiary || !!beneficiary)
    );
};

/**
 * Validates ad creative details (Panel 3)
 */
export const validateAdCreative = (
    ads: any[]
): boolean => {
    if (!ads || ads.length === 0) return false;

    return ads.every(ad =>
        !!ad.adName &&
        !!ad.primaryText &&
        !!ad.headline &&
        !!ad.descriptionText &&
        !!ad.mediaUrl
    );
};

/**
 * Validates date range
 */
export const validateDateRange = (
    startDate: dayjs.Dayjs | null,
    endDate: dayjs.Dayjs | null
): { valid: boolean; message?: string } => {
    if (!startDate) {
        return { valid: false, message: 'Start date is required' };
    }

    if (endDate && endDate.isBefore(dayjs(startDate).add(2, 'days'))) {
        return {
            valid: false,
            message: 'End date must be at least 2 days after start date',
        };
    }

    return { valid: true };
};
